import { render, staticRenderFns } from "./ChipAttributes.vue?vue&type=template&id=2f542090"
import script from "./ChipAttributes.vue?vue&type=script&lang=js"
export * from "./ChipAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports